import { RRIBaseModel } from '../../interfaces/base-model.interface';
import { RRITablePaginationSettings } from '../../interfaces/table/table-pagination-settings.interface';
import { RRTableBatchOptions } from '../../interfaces/table/table-batch-options.interface';
import { RRTableModel } from './table.model';

export class RRTableContainerModel<T extends RRIBaseModel, R> {
  tablePagination: RRITablePaginationSettings;
  table: RRTableModel<T>;
  visibleBatchOptions: RRTableBatchOptions<T, R>;
}
